import React from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { Box } from "@mui/system";
import { useLocation } from "react-router-dom";
import PublicCollectionTable from "features/Collections/components/PublicCollectionTable";

export default function BookmarksTable({
  rows,
  setRows,
  loading = false,
  filter,
}) {
  const dispatch = useDispatch();
  const { bookmarkedData } = useSelector((state) => state.data);

  const location = useLocation();
  const isPublicCollectionSrc = location.pathname.includes("/public");

  useEffect(() => {
    if (bookmarkedData.id && rows.length && bookmarkedData.switch) {
      const bookmarkedNewsData = rows.filter(
        (row) => row.sourceUrl_chr !== bookmarkedData.id
      );
      setRows(bookmarkedNewsData);
    }
  }, [
    bookmarkedData.collectionId,
    bookmarkedData.collectionSourceId,
    bookmarkedData.id,
  ]);

  return <PublicCollectionTable rows={rows} loading={loading} filter={filter} />;
}
